import React, { useState, useEffect } from 'react';
import { Container, AppBar, Toolbar, TextField, Button, Box, Modal, Tooltip, Typography, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function EditBank() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  let navigate = useNavigate();
  const [bankName, setBankName] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [accountNo, setAccountNo] = useState('');
  const [openingBalance, setOpeningBalance] = useState('');
  const { bankId } = useParams();

  useEffect(() => {
    fetchBankData();
  }, []);

  const fetchBankData = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Bank/GetBank`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const bankData = await response.json();
        const foundBank = bankData.find(item => item.bankId === parseInt(bankId));
        if (foundBank) {
          setBankName(foundBank.bankName);
          setAccountNo(foundBank.accountNo);
        } else {
          console.error('Bank not found');
        }
      } else {
        console.error('Error fetching bank data');
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  const handleUpdate = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Bank/Id?BankId=${bankId}`, {
        method: 'PUT', // or 'PATCH' depending on your API
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          bankName: bankName,
          accountNo: accountNo,
          openingBalance: parseInt(openingBalance) || 0,
        }),

      });

      if (response.ok) {
        // Handle successful update
        setShowSuccessModal(true);
      } else {
        // alert('Failed to update bank details');
        setSnackbarMessage('Failed to update bank details');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
      }
    } catch (error) {
      // alert('API request error:', error);
      setSnackbarMessage('API request error:', error);
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const handleCancel = () => {
    // Add logic to handle cancel action
    navigate(-1);
  };

  return (
    <Container mt={4}>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Edit Payment
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} sx={{ padding: 2, width: '100%', margin: 'auto', marginTop: 1 }}>
        <div>
          <TextField
            label="Payment Method"
            variant="outlined"
            fullWidth
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Account No"
            variant="outlined"
            fullWidth
            value={accountNo}
            onChange={(e) => setAccountNo(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Opening Balance"
            variant="outlined"
            fullWidth
            value={openingBalance}
            onChange={(e) => setOpeningBalance(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!bankName || !accountNo ? "Please fill all fields" : ""} arrow>
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdate}
                sx={{ mr: 2 }}
                disabled={!bankName || !accountNo}
              >
                UPDATE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Payment Updated ✅
            </Typography>
          </Box>

          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Payment details have been Updated successfully.
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

    </Container>
  );
}

export default EditBank;
